import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "product-select"
};
var _hoisted_2 = {
  class: "product-select-content"
};
var _hoisted_3 = {
  class: "product-picture"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "asin-list-box"
};
var _hoisted_6 = {
  class: "asin-list-box-content"
};
var _hoisted_7 = {
  class: "asin-list"
};
var _hoisted_8 = {
  key: 2,
  class: "subtraction-tag"
};
import { ref, computed, onMounted, toRaw, watch, inject, onActivated, nextTick } from 'vue';
import { useStore } from 'vuex';
import { showToast } from 'vant';
import BuyNow from './BuyNow.vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import { useRouter } from 'vue-router';
import { Bridge } from '@/utils/bridge';
import { useLess } from '@/models/hooks';
import PopUp from '@/components/popup/PopUp.vue';
import BuyAsinList from './BuyAsinList.vue';
import BuyTopBanner from './BuyTopBanner.vue';
import BuyDeliveryInfo from './BuyDeliveryInfo.vue';
import BuyQuantity from './BuyQuantity.vue';
import BuyAccountingBox from './BuyAccountingBox.vue';
import { getAsinDetail } from '@/models/api/detailPageApi';
import spcBuyBox from '@/views/spc/orderConfirm/components/BuyBox.vue';
import spcPaymentBox from '@/views/spc/orderConfirm/components/SPCPaymentBox.vue';
import spcAccountingBox from '@/views/spc/orderConfirm/components/SPCAccountingBox.vue';
import ShoppingAuthorizationPopup from '@/views/spc/orderConfirm/components/ShoppingAuthorizationPopup.vue';
import errorPop from '@/views/spc/orderConfirm/components/SPCErrorPop.vue';
import { batchList, handleChunkArr, allProps, TWISTER_DIMENSION } from './BuyingOptionsPopup';
import { createPurchase, prepay, signPurchaseV2 } from '@/models/api/orderConfirmApi';
import { priceCalc, errorHandle as errorHandleText, handleAddressInfo, filterAndResortKnownCVs, apiType, errorTypes, getIsPlaceOrder, handleAssociateToken } from '@/views/spc/spcUtils';
import { getTwisterByAsin, addCartList, generateRandomString, getAddressList as getAddressListAndInfo, calcMultiplicative } from '@/utils/common';
import { useI18n } from 'vue-i18n';
import { get, cloneDeep, some, isNil, filter, every, clone } from 'lodash-es';
import SkuCalculator from '@leeboyin/sku-calculator';
import imageLink from '@/configs/imageLink';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
export default {
  __name: 'BuyingOptionsPopup',
  props: _objectSpread({}, allProps),
  emits: ['update:isShowPopup', 'onConfirm', 'onPaying', 'onSelected', 'onClose', 'update:quantity', 'reloadingData'],
  setup(__props, {
    emit: emits
  }) {
    var props = __props;
    useLess('components/BuyingOptionsPopup.less');
    var NO_DATA_IMAGE = imageLink.NO_DATA_IMAGE;
    var DEFAULT_KOL = constants.DEFAULT_KOL,
      PAYMENT_LIST = constants.PAYMENT_LIST,
      NEW_IMAGE_URL = constants.NEW_IMAGE_URL,
      PAY_STATUS_RESULT = constants.PAY_STATUS_RESULT,
      CV_QUANTITY_LIMITS = constants.CV_QUANTITY_LIMITS,
      NON_RETURNABLE_FLAG = constants.NON_RETURNABLE_FLAG,
      CV_CONSENT_NOT_GRANT = constants.CV_CONSENT_NOT_GRANT,
      TWISTER_DIMESIN_KEYS = constants.TWISTER_DIMESIN_KEYS,
      GSAPP = constants.GSAPP,
      CV_ADDRESS_NOT_REACHED = constants.CV_ADDRESS_NOT_REACHED,
      USER_INTERACTION_METHOD = constants.USER_INTERACTION_METHOD,
      CV_LEGACY_ADDRESS_IN_USE = constants.CV_LEGACY_ADDRESS_IN_USE,
      AVAILABILITY_STATUS_ENUM = constants.AVAILABILITY_STATUS_ENUM,
      CV_QUANTITY_NOT_AVAILABLE = constants.CV_QUANTITY_NOT_AVAILABLE,
      CV_INVALID_COUPON_BALANCE = constants.CV_INVALID_COUPON_BALANCE,
      ADD_CART_AND_FAVORITES_STATUS = constants.ADD_CART_AND_FAVORITES_STATUS,
      CV_CUSTOMER_CONSENT_NOT_GRATED = constants.CV_CUSTOMER_CONSENT_NOT_GRATED,
      ORDER_EXTERNAL_REQUEST_ID_LENGTH = constants.ORDER_EXTERNAL_REQUEST_ID_LENGTH;
    var store = useStore();
    var router = useRouter();
    var _useI18n = useI18n(),
      t = _useI18n.t,
      te = _useI18n.te;
    var BUTTON_TYPE = {
      NORMAL_BTN: 'normalBtn',
      // Display single button OK
      DOUBLE_BTN: 'doubleBtn',
      // Display double button
      TO_PAY: 'toPay' // Go to pay
    };

    var isLoading = ref(false);
    var isShowAuthorize = ref(false);
    var isOverQuantityLimit = ref(false);
    var errorPopRef = ref(null);
    var isNewCustomer = ref(false);
    // Has payment been triggered
    var hasSigned = ref(false);
    var purchaseId = ref(null);
    var addressInfo = ref(null);
    var associateToken = inject('associateToken', null);
    var cptCheckoutStatus = computed(() => {
      var _ref;
      return (_ref = addressInfo.value !== null) !== null && _ref !== void 0 ? _ref : false;
    });
    var btnStyle = ref(BUTTON_TYPE.NORMAL_BTN);
    var getBtnStyle = () => {
      var type = BUTTON_TYPE.NORMAL_BTN;
      if (props.isAddToCart && !props.isFromAsinList || !props.isAddToCart && !cptCheckoutStatus.value && !props.isFromAsinList) {
        // Add asin to shopping cart and is not in the asin list  || Not  adding asin to shopping cart without an address and not in the asin list
        type = BUTTON_TYPE.NORMAL_BTN;
      } else if (props.isFromAsinList) {
        // In the asin list
        type = BUTTON_TYPE.DOUBLE_BTN;
      } else if (!props.isAddToCart && cptCheckoutStatus.value) {
        // Not adding asin to shopping cart and having an address
        type = BUTTON_TYPE.TO_PAY;
      }
      btnStyle.value = type;
    };
    var isPayButtonDisabled = computed(() => {
      return addressInfo.value !== null && store.state.checkout.fillKYC !== null;
    });
    var asinDetails = ref({
      specificationText: ''
    });
    var popHeight = computed(() => {
      return btnStyle.value === BUTTON_TYPE.TO_PAY ? '85%' : '72%';
    });
    var distanceFromBottom = computed(() => {
      var _ref2, _store$state$navigato;
      return (_ref2 = `${Number((_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.bottom)}px`) !== null && _ref2 !== void 0 ? _ref2 : '0';
    });
    var productStylesParam = ref([]); // Specification list
    var selectedProductIndex = ref([]); // Select the item subscript
    var quantity = ref(0); // Added quantity
    var calculatedAllPrice = ref(null); // // The total price amount is calculated and displayed
    var promotions = ref(null);
    var isSeeLargeImg = ref(false); // View picture configuration

    var seeImages = ref([]);
    var twisterValue = ref(null); // Objects of all twister
    var asinsValue = ref([]); // All asins data
    var selectedTwister = ref({}); // The currently selected twister
    var twisterColorImage = ref({}); // Picture of twister
    var twisterStatus = ref(); // Status of all twister
    var statistics = ref(); // statistical data
    var deliveryInfoRef = ref(null);
    var paymentBoxRef = ref(null);
    // Selectable specification array
    var asinCalculator = null; // Instantiated object for calculating SKU
    // Selectable twister array
    var selectionArray = computed(() => {
      var selectionList = [];
      if (!every(selectedTwister.value, isNil)) {
        selectionList.push({
          spec: clone(selectedTwister.value),
          amount: 1
        });
      }
      selectionList = filter(selectionList, selection => {
        return selection.amount > 0 || some(selection.spec, value => {
          return !isNil(value);
        });
      });
      return selectionList;
    });
    var showTip = (tip, success = false) => {
      showToast({
        message: tip,
        duration: 2500,
        className: 'a-toast',
        icon: success ? constants.SUCCESS_ICON_IMAGE_URL : '',
        overlay: false,
        overlayClass: 'a-overlay-white'
      });
    };
    watch(() => selectionArray.value, () => {
      // Recalculate optional twister
      asinCalculator.setSelectionArray(selectionArray.value);
      twisterStatus.value = cloneDeep(asinCalculator.specStatus);
      statistics.value = cloneDeep(asinCalculator.statistics);
      var selectedSkuIndex = statistics.value.determinedAmount ? Object.keys(statistics.value.determinedAmount)[0] : null;
      if (selectedSkuIndex) {
        // Assign asinDetail
        asinDetails.value = asinsValue.value[selectedSkuIndex];
        if (btnStyle.value === BUTTON_TYPE.TO_PAY) {
          // eslint-disable-next-line no-use-before-define
          getPurchaseDetail();
        }
      }
      awsRumHandler.recordClickEvent(clickEvents.detailPage.chooseProductSpecificationButton);
    });
    // Check if the twister are selectable
    function isTwisterSelectable(specName, specValue) {
      return get(twisterStatus.value, [specName, specValue, 'selectable'], false) && !get(twisterStatus.value, [specName, specValue, 'insufficient'], false);
    }
    // Click on a single twister
    function onClickTwister(name, value) {
      if (!isTwisterSelectable(name, value)) {
        return;
      }
      if (selectedTwister.value[name] === value) {
        selectedTwister.value[name] = null;
      } else {
        selectedTwister.value[name] = value;
      }
    }
    var getAddressInfo = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getAddressList, addressDefault;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAddressListAndInfo();
            case 2:
              _yield$getAddressList = _context.sent;
              addressDefault = _yield$getAddressList.addressInfo;
              addressInfo.value = addressDefault;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getAddressInfo() {
        return _ref3.apply(this, arguments);
      };
    }();
    // Processing and calculation of settlement products
    var handlePurchaseList = (list, type = apiType.createPurchase) => {
      var importFee = 0;
      var nonReturnable = false;
      var itemList = [toRaw(asinDetails.value)];
      list.forEach(item => {
        itemList === null || itemList === void 0 ? void 0 : itemList.forEach(childItem => {
          if (item.asin === childItem.asin) {
            var _childItem$globalStor, _childItem$globalStor2;
            if (childItem.nonReturnableFlag === NON_RETURNABLE_FLAG.FALSE) {
              nonReturnable = true;
            }
            importFee += (childItem === null || childItem === void 0 ? void 0 : (_childItem$globalStor = childItem.globalStore) === null || _childItem$globalStor === void 0 ? void 0 : (_childItem$globalStor2 = _childItem$globalStor.importFee) === null || _childItem$globalStor2 === void 0 ? void 0 : _childItem$globalStor2.amount) * Number(quantity.value);
          }
        });
      });
      var value = toRaw(calculatedAllPrice.value);
      if (type === apiType.createPurchase) {
        calculatedAllPrice.value = _objectSpread(_objectSpread({}, value), {}, {
          importFee,
          isNonReturnableTag: nonReturnable
        });
      } else {
        calculatedAllPrice.value = _objectSpread(_objectSpread({}, value), {}, {
          isNonReturnableTag: nonReturnable
        });
      }
      return list;
    };
    // Price assignment
    var handlePurchasePrice = allPrice => {
      var total = allPrice.total,
        discount = allPrice.discount,
        importFee = allPrice.importFee,
        shippingFee = allPrice.shippingFee,
        promotionList = allPrice.promotionList,
        shippingDiscount = allPrice.shippingDiscount,
        shippingPromotion = allPrice.shippingPromotion;
      store.commit('checkout/setDiscount', -discount);
      var totalPrice = total + importFee + shippingFee + discount;
      store.commit('checkout/setTotalPrice', totalPrice);
      calculatedAllPrice.value = _objectSpread(_objectSpread({}, toRaw(calculatedAllPrice.value)), {}, {
        total,
        importFee,
        shippingPromotion,
        originalShippingFee: shippingFee,
        discount: -(discount - shippingDiscount),
        shippingFee: shippingFee + shippingDiscount,
        promotionList: Array.from(promotionList.values())
      });
    };

    // View Details Invoke the creation order interface to obtain the money details of the selected data
    var getPurchaseDetail = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var associatesInfo, payList, _yield$createPurchase, data, _priceCalc, list, allPrice, _data$kycItemModel, _data$kycItemModel2, _data$kycItemModel3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isLoading.value = true;
              associatesInfo = associateToken !== null && associateToken !== void 0 && associateToken.value ? handleAssociateToken(associateToken.value, asinDetails.value.merchantId) : false;
              payList = [_objectSpread({
                asin: asinDetails.value.asin,
                quantity: Number(quantity.value),
                asinDetail: {
                  merchantId: asinDetails.value.merchantId
                }
              }, associatesInfo && {
                associatesInfo
              })];
              _context2.prev = 3;
              _context2.next = 6;
              return createPurchase(_objectSpread(_objectSpread({}, addressInfo.value && {
                addressInfo: handleAddressInfo(addressInfo.value)
              }), {}, {
                items: payList,
                externalPlatform: GSAPP,
                externalSellerId: DEFAULT_KOL,
                purchaseSessionId: '457-9196418-2840651',
                // API issue, temporarily using fixed values
                requestId: generateRandomString(ORDER_EXTERNAL_REQUEST_ID_LENGTH),
                suppressPrice: false
              }));
            case 6:
              _yield$createPurchase = _context2.sent;
              data = _yield$createPurchase.data;
              purchaseId.value = data.purchaseId;
              store.commit('checkout/setPurchaseId', data.purchaseId);
              _priceCalc = priceCalc(data === null || data === void 0 ? void 0 : data.orderDetailList), list = _priceCalc.list, allPrice = _priceCalc.allPrice;
              handlePurchaseList(list, apiType.createPurchase);
              handlePurchasePrice(allPrice);
              store.commit('checkout/setAddressId', data === null || data === void 0 ? void 0 : data.obfuscatedAddressId);
              if (data !== null && data !== void 0 && data.kycItemModel) {
                store.commit('checkout/setFillKYC', {
                  maskedId: (_data$kycItemModel = data.kycItemModel) === null || _data$kycItemModel === void 0 ? void 0 : _data$kycItemModel.maskedId,
                  kycId: (_data$kycItemModel2 = data.kycItemModel) === null || _data$kycItemModel2 === void 0 ? void 0 : _data$kycItemModel2.kycId,
                  holderName: (_data$kycItemModel3 = data.kycItemModel) === null || _data$kycItemModel3 === void 0 ? void 0 : _data$kycItemModel3.holderName,
                  maskedPhoneNumber: data === null || data === void 0 ? void 0 : data.maskedPhoneNumber,
                  frontCitizenUploadToken: data === null || data === void 0 ? void 0 : data.frontCitizenUploadToken,
                  backCitizenUploadToken: data === null || data === void 0 ? void 0 : data.backCitizenUploadToken
                });
              }
              _context2.next = 21;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](3);
              isLoading.value = false;
              showTip(t('modules.checkout.FAILED_TO_CREATE_ORDER'));
            case 21:
              _context2.prev = 21;
              isLoading.value = false;
              return _context2.finish(21);
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 17, 21, 24]]);
      }));
      return function getPurchaseDetail() {
        return _ref4.apply(this, arguments);
      };
    }();
    var getSelectedAsinDetail = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(selectedAsin = props.selectedAsin) {
        var _currentValue$asinTex, _data$twisterVariatio, _data$twisterVariatio2, _skus$find$spec, _skus$find;
        var _yield$getAsinDetail, data, _errorPopRef$value, currentValue, specs, dimensionKeys, dimensionValues, variations, skus, asinList, chunkPromiselist, batchPromiselist, batchData, allResult, currentTwisterValue, colorImg;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              isLoading.value = true;
              productStylesParam.value = [];
              _context3.next = 4;
              return getAsinDetail({
                id: selectedAsin,
                marketplace: encryptedMarketplaceId,
                allowOtherOffer: true,
                merchantId: props.merchantId
              });
            case 4:
              _yield$getAsinDetail = _context3.sent;
              data = _yield$getAsinDetail.data;
              if (data.stockOnHand) {
                _context3.next = 10;
                break;
              }
              isLoading.value = false;
              errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value = errorPopRef.value) === null || _errorPopRef$value === void 0 ? void 0 : _errorPopRef$value.errorfn(errorTypes.ALL_OUT_OF_STOCK);
              return _context3.abrupt("return");
            case 10:
              asinDetails.value = JSON.parse(JSON.stringify(data));
              currentValue = getTwisterByAsin(data);
              asinDetails.value.specificationText = (_currentValue$asinTex = currentValue === null || currentValue === void 0 ? void 0 : currentValue.asinText) !== null && _currentValue$asinTex !== void 0 ? _currentValue$asinTex : '';
              selectedProductIndex.value = currentValue.values;
              if (!(!((_data$twisterVariatio = data.twisterVariations) !== null && _data$twisterVariatio !== void 0 && _data$twisterVariatio.dimensionKeys) || !((_data$twisterVariatio2 = data.twisterVariations) !== null && _data$twisterVariatio2 !== void 0 && _data$twisterVariatio2.dimensionValues))) {
                _context3.next = 20;
                break;
              }
              isLoading.value = false;
              if (!(btnStyle.value === BUTTON_TYPE.TO_PAY)) {
                _context3.next = 19;
                break;
              }
              _context3.next = 19;
              return getPurchaseDetail();
            case 19:
              return _context3.abrupt("return");
            case 20:
              specs = {};
              dimensionKeys = data.twisterVariations.dimensionKeys;
              dimensionValues = data.twisterVariations.dimensionValues;
              variations = data.twisterVariations.variations; // Obtain all ASIN numbers and combinations from the API
              dimensionValues.forEach((item, index) => {
                var keys = dimensionKeys[index].symbol;
                specs[keys] = item;
              });
              twisterValue.value = specs;
              skus = [];
              asinList = [];
              variations.forEach(item => {
                var spec = {};
                item.values.forEach((specItem, specIndex) => {
                  var keys = dimensionKeys[specIndex].symbol;
                  var value = dimensionValues[specIndex][specItem];
                  spec[keys] = value;
                });
                // Filter out dirty data
                if (dimensionValues.length === item.values.length) {
                  skus.push({
                    spec,
                    asin: item.asin,
                    values: item.values
                  });
                  asinList.push(item.asin);
                }
              });
              // Obtain ASIN details
              chunkPromiselist = handleChunkArr(asinList);
              batchPromiselist = [];
              chunkPromiselist.forEach(item => {
                batchPromiselist.push(batchList(item.join()));
              });
              _context3.next = 34;
              return Promise.all(batchPromiselist);
            case 34:
              batchData = _context3.sent;
              allResult = batchData.flat(1);
              allResult.forEach(result => {
                skus.forEach(sku => {
                  if (sku.asin === result.asin) {
                    Object.assign(sku, result, {
                      amount: result.stockOnHand
                    });
                  }
                });
              });
              asinsValue.value = skus;
              asinCalculator = new SkuCalculator({
                specs,
                skus,
                hasAmount: true
              });
              twisterStatus.value = asinCalculator.specStatus;
              statistics.value = asinCalculator.statistics;
              // Obtain the currently selected Twister value
              currentTwisterValue = (_skus$find$spec = (_skus$find = skus.find(item => item.asin === selectedAsin)) === null || _skus$find === void 0 ? void 0 : _skus$find.spec) !== null && _skus$find$spec !== void 0 ? _skus$find$spec : [];
              Object.entries(currentTwisterValue).forEach(item => {
                onClickTwister(item[0], item[1]);
              });
              // Get images of all colors
              colorImg = {};
              skus.forEach(item => {
                var _specs$color_name;
                specs === null || specs === void 0 ? void 0 : (_specs$color_name = specs.color_name) === null || _specs$color_name === void 0 ? void 0 : _specs$color_name.forEach(i => {
                  if (i === item.spec.color_name && item !== null && item !== void 0 && item.mainImage) {
                    if (!(colorImg !== null && colorImg !== void 0 && colorImg[item.spec.color_name])) {
                      colorImg[item.spec.color_name] = item === null || item === void 0 ? void 0 : item.mainImage;
                    }
                  }
                });
              });
              twisterColorImage.value = colorImg;
              isLoading.value = false;
              if (!(btnStyle.value === BUTTON_TYPE.TO_PAY)) {
                _context3.next = 50;
                break;
              }
              _context3.next = 50;
              return getPurchaseDetail();
            case 50:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getSelectedAsinDetail() {
        return _ref5.apply(this, arguments);
      };
    }();
    var changeAddress = () => {
      getPurchaseDetail();
    };
    var quantityChange = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _asinDetails$value;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              emits('update:quantity', quantity.value);
              if (!(btnStyle.value === BUTTON_TYPE.TO_PAY)) {
                _context4.next = 6;
                break;
              }
              if ((_asinDetails$value = asinDetails.value) !== null && _asinDetails$value !== void 0 && _asinDetails$value.asin) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return getPurchaseDetail();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function quantityChange() {
        return _ref6.apply(this, arguments);
      };
    }();
    var errorHandleFn = {
      allOutOfStock: function () {
        var _allOutOfStock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                emits('update:isShowPopup', false);
                emits('reloadingData');
              case 2:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function allOutOfStock() {
          return _allOutOfStock.apply(this, arguments);
        }
        return allOutOfStock;
      }()
    };
    // Errors returned by public processing APIs
    var handleErrorReason = error => {
      var _error$checkOutErrorD;
      if ((error === null || error === void 0 ? void 0 : (_error$checkOutErrorD = error.checkOutErrorDetailModelList) === null || _error$checkOutErrorD === void 0 ? void 0 : _error$checkOutErrorD.length) > 0) {
        var _error$checkOutErrorD2;
        var errorDetail = error === null || error === void 0 ? void 0 : (_error$checkOutErrorD2 = error.checkOutErrorDetailModelList[0]) === null || _error$checkOutErrorD2 === void 0 ? void 0 : _error$checkOutErrorD2.reason;
        if (errorDetail === CV_LEGACY_ADDRESS_IN_USE || errorDetail === CV_ADDRESS_NOT_REACHED) {
          return true; // Address anomaly
        }

        if (errorDetail === CV_CONSENT_NOT_GRANT || errorDetail === CV_CUSTOMER_CONSENT_NOT_GRATED) {
          isShowAuthorize.value = true; // unauthorized
          return true;
        }
        if (errorDetail === CV_QUANTITY_LIMITS) {
          var _error$checkOutErrorD3, _error$checkOutErrorD4, _error$checkOutErrorD5;
          // quantity limit
          var quantityErr = (_error$checkOutErrorD3 = error === null || error === void 0 ? void 0 : (_error$checkOutErrorD4 = error.checkOutErrorDetailModelList[0]) === null || _error$checkOutErrorD4 === void 0 ? void 0 : (_error$checkOutErrorD5 = _error$checkOutErrorD4.errorQuantityContext) === null || _error$checkOutErrorD5 === void 0 ? void 0 : _error$checkOutErrorD5.QuantityPurchasable) !== null && _error$checkOutErrorD3 !== void 0 ? _error$checkOutErrorD3 : 0;
          if (quantityErr > 1) {
            isOverQuantityLimit.value = true;
            quantity.value = quantityErr;
            showTip(errorHandleText.overQuantityLimit.tipErrorText);
          } else {
            var _errorPopRef$value2;
            errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value2 = errorPopRef.value) === null || _errorPopRef$value2 === void 0 ? void 0 : _errorPopRef$value2.errorfn(errorTypes.ALL_OUT_OF_STOCK);
          }
          return true;
        }
        if (errorDetail === CV_QUANTITY_NOT_AVAILABLE) {
          var _errorPopRef$value3;
          errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value3 = errorPopRef.value) === null || _errorPopRef$value3 === void 0 ? void 0 : _errorPopRef$value3.errorfn(errorTypes.ALL_OUT_OF_STOCK);
          return true;
        }
        if (errorDetail === CV_INVALID_COUPON_BALANCE) {
          var _errorPopRef$value4;
          errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value4 = errorPopRef.value) === null || _errorPopRef$value4 === void 0 ? void 0 : _errorPopRef$value4.errorfn(errorTypes.INVALID_COUPON);
          return true;
        }
      }
      return false;
    };
    var prePay = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _yield$prepay, payData, _yield$Bridge$callFnV, payResult, orderPrice;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              store.commit('checkout/setFromPage', asinDetails.value.asin);
              _context6.prev = 1;
              isLoading.value = true;
              _context6.next = 5;
              return prepay({
                userInteractionMethod: USER_INTERACTION_METHOD,
                externalPlatform: GSAPP,
                purchaseId: purchaseId.value,
                requestId: generateRandomString(ORDER_EXTERNAL_REQUEST_ID_LENGTH)
              });
            case 5:
              _yield$prepay = _context6.sent;
              payData = _yield$prepay.data;
              isLoading.value = false;
              emits('update:isShowPopup', false);
              _context6.next = 11;
              return Bridge.callFnVal('payOrder', {
                payType: PAYMENT_LIST[0].type,
                payData: payData === null || payData === void 0 ? void 0 : payData.redirectParameters
              });
            case 11:
              _yield$Bridge$callFnV = _context6.sent;
              payResult = _yield$Bridge$callFnV.result;
              // pay success
              if (payResult === PAY_STATUS_RESULT.PAYSUCCESS) {
                if (isNewCustomer.value) {
                  Bridge.callFnVal('changeCurrentCustomerActualPurchaseStatus', {
                    hasActualPurchase: true
                  });
                  orderPrice = calcMultiplicative(store.state.checkout.totalPrice.toFixed(2), 100);
                  Bridge.callFnVal('reportEventToServer', {
                    eventType: 'placeOrder',
                    eventData: JSON.stringify({
                      orderPrice
                    })
                  });
                  Bridge.callFnVal('reportPayOrderToTalkingData', {
                    orderId: purchaseId.value,
                    total: orderPrice,
                    paymentType: PAYMENT_LIST[0].type
                  });
                }
                router.replace({
                  name: 'paySuccess'
                });
              } else if (payResult === PAY_STATUS_RESULT.ABNORMAL) {
                router.replace({
                  name: 'payAbnormal'
                });
              } else {
                // pay fail
                router.replace({
                  name: 'payFail'
                });
              }
              _context6.next = 20;
              break;
            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](1);
              isLoading.value = false;
              showTip(t('modules.checkout.MAXIMUM_PAYMENT_LIMIT_EXCEEDED'));
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[1, 16]]);
      }));
      return function prePay() {
        return _ref7.apply(this, arguments);
      };
    }();
    // Handling situations where ASIN is not selected
    var handleNotSelectedAsin = () => {
      var notSelectedIndex = Object.entries(selectedTwister.value).findIndex(i => i[1] === null);
      if (notSelectedIndex !== -1) {
        var noSelectedTwister = Object.entries(selectedTwister.value)[notSelectedIndex][0];
        var tipText = `${t('modules.checkout.PLEASE_SELECT')}${te(`modules.checkout.${TWISTER_DIMENSION[noSelectedTwister]}`) ? t(`modules.checkout.${TWISTER_DIMENSION[noSelectedTwister]}`) : noSelectedTwister}`;
        showTip(tipText);
        return false;
      }
      return true;
    };
    var getIsStockOnHand = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _yield$getAsinDetail2, data, _errorPopRef$value5;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return getAsinDetail({
                id: asinDetails.value.asin,
                marketplace: encryptedMarketplaceId,
                allowOtherOffer: true,
                merchantId: props.merchantId
              });
            case 2:
              _yield$getAsinDetail2 = _context7.sent;
              data = _yield$getAsinDetail2.data;
              if (data.stockOnHand) {
                _context7.next = 7;
                break;
              }
              errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value5 = errorPopRef.value) === null || _errorPopRef$value5 === void 0 ? void 0 : _errorPopRef$value5.errorfn(errorTypes.ALL_OUT_OF_STOCK);
              return _context7.abrupt("return", false);
            case 7:
              return _context7.abrupt("return", true);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function getIsStockOnHand() {
        return _ref8.apply(this, arguments);
      };
    }();
    var checkPay = () => {
      if (!addressInfo.value) {
        showTip(t('modules.checkout.PLEASE_FILL_SHIPPING_ADDRESS'));
        return;
      }
      if (!store.state.checkout.fillKYC) {
        showTip(t('modules.checkout.PLEASE_PROVIDE_KYC'));
      }
    };
    var handelPay = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _yield$getIsPlaceOrde, isPlaceOrder, title, content, _errorPopRef$value6, _yield$Bridge$callFnV2, hasWeChat, _errorPopRef$value7, _error$data, _error$data$CVList, vipCV, sortedCVs, _vipCV, _errorPopRef$value8;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (handleNotSelectedAsin()) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              _context8.next = 4;
              return getIsStockOnHand();
            case 4:
              if (_context8.sent) {
                _context8.next = 6;
                break;
              }
              return _context8.abrupt("return");
            case 6:
              _context8.next = 8;
              return getIsPlaceOrder();
            case 8:
              _yield$getIsPlaceOrde = _context8.sent;
              isPlaceOrder = _yield$getIsPlaceOrde.isPlaceOrder;
              title = _yield$getIsPlaceOrde.title;
              content = _yield$getIsPlaceOrde.content;
              if (isPlaceOrder) {
                _context8.next = 15;
                break;
              }
              errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value6 = errorPopRef.value) === null || _errorPopRef$value6 === void 0 ? void 0 : _errorPopRef$value6.errorfn(errorTypes.NOT_PLACE_ORDER, title, content);
              return _context8.abrupt("return");
            case 15:
              _context8.next = 17;
              return Bridge.callFnVal('checkWeChatAppHasInstalled');
            case 17:
              _yield$Bridge$callFnV2 = _context8.sent;
              hasWeChat = _yield$Bridge$callFnV2.result;
              if (hasWeChat) {
                _context8.next = 22;
                break;
              }
              errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value7 = errorPopRef.value) === null || _errorPopRef$value7 === void 0 ? void 0 : _errorPopRef$value7.errorfn(errorTypes.UNINSTALL_WECHAT);
              return _context8.abrupt("return");
            case 22:
              isLoading.value = true;
              _context8.prev = 23;
              if (hasSigned.value) {
                _context8.next = 33;
                break;
              }
              _context8.next = 27;
              return signPurchaseV2({
                externalPlatform: GSAPP,
                externalSellerId: DEFAULT_KOL,
                purchaseId: purchaseId.value,
                requestId: generateRandomString(ORDER_EXTERNAL_REQUEST_ID_LENGTH)
              });
            case 27:
              hasSigned.value = true;
              _context8.next = 30;
              return prePay();
            case 30:
              Bridge.callFnVal('clearAssociateToken');
              _context8.next = 35;
              break;
            case 33:
              _context8.next = 35;
              return prePay();
            case 35:
              _context8.next = 44;
              break;
            case 37:
              _context8.prev = 37;
              _context8.t0 = _context8["catch"](23);
              isLoading.value = false;
              showTip(t('modules.checkout.FAILED_TO_CREATE_ORDER'));
              if (!handleErrorReason(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.data)) {
                _context8.next = 43;
                break;
              }
              return _context8.abrupt("return");
            case 43:
              if ((_context8.t0 === null || _context8.t0 === void 0 ? void 0 : (_error$data = _context8.t0.data) === null || _error$data === void 0 ? void 0 : (_error$data$CVList = _error$data.CVList) === null || _error$data$CVList === void 0 ? void 0 : _error$data$CVList.length) > 0) {
                vipCV = null;
                sortedCVs = filterAndResortKnownCVs(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.data.CVList);
                if ((sortedCVs === null || sortedCVs === void 0 ? void 0 : sortedCVs.length) > 0) {
                  vipCV = sortedCVs[0].cv;
                  if ((_vipCV = vipCV) !== null && _vipCV !== void 0 && _vipCV.reason) {
                    errorPopRef === null || errorPopRef === void 0 ? void 0 : (_errorPopRef$value8 = errorPopRef.value) === null || _errorPopRef$value8 === void 0 ? void 0 : _errorPopRef$value8.errorfn(errorTypes.UNKNOWN_FAIL);
                  }
                }
              }
            case 44:
              _context8.prev = 44;
              isLoading.value = false;
              return _context8.finish(44);
            case 47:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[23, 37, 44, 47]]);
      }));
      return function handelPay() {
        return _ref9.apply(this, arguments);
      };
    }();

    //  Add to cart
    var onAddCart = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var asin;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (handleNotSelectedAsin()) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              asin = asinDetails.value.asin;
              awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.detailPage.addToCartButton), {}, {
                asinid: asin
              }));
              if (!props.isProductReplace) {
                _context9.next = 7;
                break;
              }
              _context9.next = 7;
              return Bridge.callFnVal('deleteShoppingCartList', {
                asins: [props.selectedAsin]
              });
            case 7:
              addCartList(asin, props.merchantId, quantity.value, true, res => {
                showTip(t('modules.checkout.SUCCESS_ADD_CART'), true);
                emits('update:isShowPopup', false);
                emits('onConfirm', res);
              });
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function onAddCart() {
        return _ref10.apply(this, arguments);
      };
    }();

    // Go to pay
    var onPaying = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (handleNotSelectedAsin()) {
                _context10.next = 2;
                break;
              }
              return _context10.abrupt("return");
            case 2:
              _context10.next = 4;
              return getIsStockOnHand();
            case 4:
              if (_context10.sent) {
                _context10.next = 6;
                break;
              }
              return _context10.abrupt("return");
            case 6:
              store.commit('checkout/setCheckoutItemList', [{
                count: quantity.value,
                productItem: asinDetails.value
              }]);
              store.commit('checkout/setFromPage', asinDetails.value.asin);
              Bridge.callFn('saveDataToMemoryCache', {
                key: 'checkoutList',
                value: [_objectSpread({
                  count: quantity.value,
                  productItem: asinDetails.value
                }, (associateToken === null || associateToken === void 0 ? void 0 : associateToken.value) && {
                  associateToken: associateToken.value
                })]
              });
              emits('update:isShowPopup', false);
              store.commit('checkout/setIsNewCustomerGuidePopupOpened', false);
              router.push({
                name: 'orderConfirm',
                params: {
                  from: asinDetails.value.asin
                }
              });
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return function onPaying() {
        return _ref11.apply(this, arguments);
      };
    }();
    var onClose = () => {
      emits('onClose', asinDetails.value);
      emits('update:isShowPopup', false);
    };
    // View picture
    var seeLargeImg = url => {
      isSeeLargeImg.value = true;
      seeImages.value = [url];
    };

    // If there is a change in isCloseBuyingOptionsPopup, actively close the current component
    watch(() => store.state.cart.isCloseBuyingOptionsPopup, () => {
      emits('update:isShowPopup', false);
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return getAddressInfo();
          case 2:
            getBtnStyle();
            asinDetails.value = {
              specificationText: ''
            };
            getSelectedAsinDetail();
            quantity.value = props.quantity;
          case 6:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    })));
    onActivated( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var _deliveryInfoRef$valu;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return (_deliveryInfoRef$valu = deliveryInfoRef.value) === null || _deliveryInfoRef$valu === void 0 ? void 0 : _deliveryInfoRef$valu.getAddressList();
          case 2:
            _context13.next = 4;
            return nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
              var _store$state$checkout, _addressInfo$value;
              return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    if (!(btnStyle.value === BUTTON_TYPE.TO_PAY)) {
                      _context12.next = 6;
                      break;
                    }
                    if (((_store$state$checkout = store.state.checkout.fillAddress) === null || _store$state$checkout === void 0 ? void 0 : _store$state$checkout.id) === ((_addressInfo$value = addressInfo.value) === null || _addressInfo$value === void 0 ? void 0 : _addressInfo$value.id) || store.state.checkout.isAddAddress) {
                      addressInfo.value = store.state.checkout.fillAddress;
                    }
                    _context12.next = 4;
                    return getPurchaseDetail();
                  case 4:
                    _context12.next = 6;
                    return paymentBoxRef.value.getKycInfo();
                  case 6:
                  case "end":
                    return _context12.stop();
                }
              }, _callee12);
            })));
          case 4:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    })));
    return (_ctx, _cache) => {
      var _component_van_image_preview = _resolveComponent("van-image-preview");
      var _component_van_popup = _resolveComponent("van-popup");
      var _directive_lazy = _resolveDirective("lazy");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: _ctx.isShowPopup,
        closeable: "",
        round: "",
        position: "bottom",
        style: _normalizeStyle({
          height: popHeight.value,
          width: '100%',
          marginBottom: _ctx.marginBottom + 'px'
        }),
        "close-icon": "cross",
        "close-on-popstate": true,
        onClose: onClose,
        "overlay-class": "a-overlay"
      }, {
        default: _withCtx(() => {
          var _asinDetails$value2, _asinDetails$value3, _asinDetails$value5, _calculatedAllPrice$v, _calculatedAllPrice$v2, _asinDetails$value6, _promotions$value;
          return [_createVNode(BuyTopBanner, {
            popHeight: popHeight.value,
            asinDetails: asinDetails.value,
            style: _normalizeStyle({
              marginBottom: _ctx.marginBottom + 'px'
            })
          }, null, 8, ["popHeight", "asinDetails", "style"]), _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["buying-options-popup", {
              'pay-pop': btnStyle.value === BUTTON_TYPE.TO_PAY
            }])
          }, [btnStyle.value == BUTTON_TYPE.TO_PAY ? (_openBlock(), _createBlock(BuyDeliveryInfo, {
            key: 0,
            isLoading: isLoading.value,
            onChangeAddress: changeAddress,
            addressInfo: addressInfo.value,
            "onUpdate:addressInfo": _cache[0] || (_cache[0] = $event => addressInfo.value = $event),
            asinDetails: asinDetails.value,
            ref_key: "deliveryInfoRef",
            ref: deliveryInfoRef
          }, null, 8, ["isLoading", "addressInfo", "asinDetails"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_asinDetails$value2 = asinDetails.value) !== null && _asinDetails$value2 !== void 0 && _asinDetails$value2.mainImage ? _withDirectives((_openBlock(), _createElementBlock("img", {
            key: (_asinDetails$value3 = asinDetails.value) === null || _asinDetails$value3 === void 0 ? void 0 : _asinDetails$value3.mainImage,
            onClick: _cache[1] || (_cache[1] = $event => {
              var _asinDetails$value4;
              return seeLargeImg((_asinDetails$value4 = asinDetails.value) === null || _asinDetails$value4 === void 0 ? void 0 : _asinDetails$value4.mainImage);
            }),
            alt: ""
          })), [[_directive_lazy, (_asinDetails$value5 = asinDetails.value) === null || _asinDetails$value5 === void 0 ? void 0 : _asinDetails$value5.mainImage]]) : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _unref(NO_DATA_IMAGE),
            alt: ""
          }, null, 8, _hoisted_4))]), _createVNode(BuyAccountingBox, {
            asinDetails: asinDetails.value,
            promotions: promotions.value,
            quantity: quantity.value,
            promotionInfoList: _ctx.promotionInfoList,
            selectedTwister: selectedTwister.value
          }, null, 8, ["asinDetails", "promotions", "quantity", "promotionInfoList", "selectedTwister"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(BuyAsinList, {
            onSeeLargeImg: seeLargeImg,
            asinDetails: asinDetails.value,
            twisterStatus: twisterStatus.value,
            twisterValue: twisterValue.value,
            selectedTwister: selectedTwister.value,
            twisterColorImage: twisterColorImage.value,
            onOnClickTwister: onClickTwister
          }, null, 8, ["asinDetails", "twisterStatus", "twisterValue", "selectedTwister", "twisterColorImage"]), _createVNode(BuyQuantity, {
            asinDetails: asinDetails.value,
            quantity: quantity.value,
            "onUpdate:quantity": _cache[2] || (_cache[2] = $event => quantity.value = $event),
            isOverQuantityLimit: isOverQuantityLimit.value,
            onQuantityChange: quantityChange
          }, null, 8, ["asinDetails", "quantity", "isOverQuantityLimit"])]), btnStyle.value === BUTTON_TYPE.TO_PAY && calculatedAllPrice.value ? (_openBlock(), _createBlock(spcAccountingBox, {
            key: 0,
            price: calculatedAllPrice.value,
            promotions: promotions.value,
            "onUpdate:promotions": _cache[3] || (_cache[3] = $event => promotions.value = $event),
            addressInfo: addressInfo.value,
            onUpdatePurchase: getPurchaseDetail,
            isNewCustomer: isNewCustomer.value,
            "onUpdate:isNewCustomer": _cache[4] || (_cache[4] = $event => isNewCustomer.value = $event)
          }, null, 8, ["price", "promotions", "addressInfo", "isNewCustomer"])) : _createCommentVNode("", true), btnStyle.value === BUTTON_TYPE.TO_PAY && calculatedAllPrice.value ? (_openBlock(), _createBlock(spcPaymentBox, {
            key: 1,
            price: calculatedAllPrice.value,
            onHandleCompleteKyc: getPurchaseDetail,
            ref_key: "paymentBoxRef",
            ref: paymentBoxRef
          }, null, 8, ["price"])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
            class: "buying-box",
            style: _normalizeStyle({
              paddingBottom: distanceFromBottom.value
            })
          }, [btnStyle.value === BUTTON_TYPE.TO_PAY ? (_openBlock(), _createBlock(spcBuyBox, {
            key: 0,
            onPay: handelPay,
            onCheckPay: checkPay,
            isPayButtonDisabled: isPayButtonDisabled.value,
            isLoading: isLoading.value,
            total: (_calculatedAllPrice$v = calculatedAllPrice.value) === null || _calculatedAllPrice$v === void 0 ? void 0 : _calculatedAllPrice$v.total,
            nums: quantity.value,
            nonReturnableTag: (_calculatedAllPrice$v2 = calculatedAllPrice.value) === null || _calculatedAllPrice$v2 === void 0 ? void 0 : _calculatedAllPrice$v2.isNonReturnableTag,
            price: calculatedAllPrice.value,
            asinsList: [(_asinDetails$value6 = asinDetails.value) === null || _asinDetails$value6 === void 0 ? void 0 : _asinDetails$value6.asin]
          }, null, 8, ["isPayButtonDisabled", "isLoading", "total", "nums", "nonReturnableTag", "price", "asinsList"])) : (_openBlock(), _createBlock(BuyNow, {
            key: 1,
            isAddToCart: _ctx.isAddToCart,
            showBtn: btnStyle.value,
            isLoading: isLoading.value,
            asinDetails: asinDetails.value,
            promotionInfoList: _ctx.promotionInfoList,
            onOnAddCart: onAddCart,
            onOnPaying: onPaying
          }, null, 8, ["isAddToCart", "showBtn", "isLoading", "asinDetails", "promotionInfoList"])), (_promotions$value = promotions.value) !== null && _promotions$value !== void 0 && _promotions$value.text ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.$t('modules.checkout.CURRENT_PRODUCT_AVAILABLE')) + "  ", 1), _createElementVNode("span", null, _toDisplayString(_unref(t)('common.REDUCTION_COUPON', {
            amount: promotions.value.threshold,
            promotion: promotions.value.amount
          })), 1)])) : _createCommentVNode("", true)], 4)], 2)), [[_directive_loading, isLoading.value]]), _createVNode(_component_van_image_preview, {
            overlayClass: "image-preview-overlay",
            show: isSeeLargeImg.value,
            "onUpdate:show": _cache[5] || (_cache[5] = $event => isSeeLargeImg.value = $event),
            images: seeImages.value,
            showIndex: false
          }, null, 8, ["show", "images"]), _createVNode(errorPop, {
            ref_key: "errorPopRef",
            ref: errorPopRef,
            errorHandleFn: errorHandleFn
          }, null, 512), _createVNode(ShoppingAuthorizationPopup, {
            show: isShowAuthorize.value,
            "onUpdate:show": _cache[6] || (_cache[6] = $event => isShowAuthorize.value = $event)
          }, null, 8, ["show"])];
        }),
        _: 1
      }, 8, ["show", "style"]);
    };
  }
};